export default "__VITE_ASSET__e8ee0bc1__"